import { Control, Controller, FieldErrors, useWatch } from 'react-hook-form';
import { CreateProductFormSchemaType } from '../common';
import { FormLabel } from '../form-label';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { InputNumber } from 'antd';
import { findLabelByValue } from 'commons/options';
import { priceToWithoutTax } from 'utils/price-change';
import { CURRENCY_MAP, CURRENCY_OPTION_LIST } from 'constant/currency';

const ProductCostPrice = ({
  control,
  errors,
  disabled,
  minCostPrice,
}: {
  control: Control<CreateProductFormSchemaType>;
  errors: FieldErrors<CreateProductFormSchemaType>;
  disabled: boolean;
  minCostPrice: number;
}) => {
  const currency = useWatch({ control, name: 'currency' });

  return (
    <div className="flex items-center gap-2">
      <FormLabel required>{i18n.t(LOCALS.purchase_price)}:</FormLabel>
      <Controller
        name="costPrice"
        control={control}
        render={({ field }) => {
          return (
            <div className="relative w-full">
              <InputNumber
                addonBefore={
                  currency
                    ? findLabelByValue(currency, CURRENCY_OPTION_LIST)
                    : null
                }
                {...field}
                status={errors.costPrice ? 'error' : undefined}
                className="w-full"
                max={99999999}
                min={minCostPrice}
                disabled={disabled}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
                parser={(value) => value!.replace(/\$\s?|(,*)/g, '') as any}
                placeholder={i18n.t(LOCALS.please_enter) || ''}
                addonAfter={
                  currency === CURRENCY_MAP.JPY ? (
                    <span>
                      {i18n.t(LOCALS.czbRYWhFdZ)}：
                      {(field.value
                        ? priceToWithoutTax(field.value)
                        : 0
                      ).toLocaleString()}
                    </span>
                  ) : null
                }
              />
              {errors.costPrice && (
                <p style={{ color: 'red' }} className="absolute left-0">
                  {i18n.t(LOCALS.required_field)}
                </p>
              )}
            </div>
          );
        }}
      />
    </div>
  );
};

export default ProductCostPrice;
